/* LK VIDEO PRODUIT - lit les videos de la galerie lp9 (vignettes .lp9-thumb--video, data-video = mp4 Shopify).
   Ordinateur : un clic sur la vignette video remplace l'image principale par le lecteur ; un clic sur une photo la remet.
   Mobile : la diapo du carrousel (lk-gallery-swipe.js) qui correspond a la video devient un lecteur
   (pas de zoom sur cette diapo) ; la video se met en pause quand on glisse vers une autre photo.
   Option C (validee par Brandon le 25/10) : pastille "Voir la degustation - 0:23" posee sur la photo
   + duree sur la vignette video ; la pastille disparait quand la video est affichee.
   Sur mobile, la vignette video lance la lecture comme la pastille (25/10, depuis le debut si finie).
   Fiches sans video : rien ne change. Ajoute 2026-10-24, pastille 2026-10-25. */
(function () {
  var CSS = [
    '.lk-video-main,.lk-swipe-slide video.lk-video-slide{display:block;width:100%;max-width:640px;aspect-ratio:1/1;',
    'object-fit:contain;background:#111;border-radius:24px;',
    'box-shadow:0 20px 40px -10px rgba(233,30,99,.12),0 0 0 1px rgba(0,0,0,.04);}',
    '.lk-video-main[hidden]{display:none !important;}',
    '.lp9-media.lk-video-on>#lp9MainImg{display:none;}',
    '.lk-video-pill{position:absolute;left:14px;bottom:14px;z-index:3;height:40px;margin:0;padding:0 14px 0 5px;',
    'border:1px solid rgba(233,30,99,.18);border-radius:999px;background:rgba(255,255,255,.96);',
    'display:flex;align-items:center;gap:8px;box-shadow:0 8px 20px rgba(0,0,0,.12);cursor:pointer;font:inherit;}',
    '.lk-video-pill[hidden]{display:none;}',
    '.lk-vp-ico{width:30px;height:30px;border-radius:50%;background:#e91e63;display:flex;align-items:center;justify-content:center;flex-shrink:0;}',
    '.lk-vp-txt{font-family:Poppins,sans-serif;font-weight:700;font-size:13px;color:#1f1218;white-space:nowrap;}',
    '.lk-vp-dur{font-size:13px;font-weight:600;color:#6b5860;}',
    '.lk-vt-dur{position:absolute;right:3px;bottom:3px;background:rgba(17,17,17,.82);color:#fff;font-size:10px;',
    'font-weight:700;line-height:1.4;padding:1px 5px;border-radius:6px;pointer-events:none;}'
  ].join('');
  var PLAY = '<svg width="12" height="12" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 4l14 8-14 8z" fill="#ffffff"></path></svg>';

  function addStyle() {
    if (document.getElementById('lk-video-style')) { return; }
    var st = document.createElement('style');
    st.id = 'lk-video-style';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  function isMobile() { return window.matchMedia('(max-width:767px)').matches; }

  /* 23500 (ms) -> "0:23" ; vide si inconnu */
  function duree(t) {
    var ms = parseInt(t.getAttribute('data-duree'), 10);
    if (!ms || ms < 1000) { return ''; }
    var s = Math.floor(ms / 1000);
    var r = s % 60;
    return Math.floor(s / 60) + ':' + (r < 10 ? '0' : '') + r;
  }

  function makeVideo(thumb, cls) {
    var v = document.createElement('video');
    v.className = cls;
    v.src = thumb.getAttribute('data-video');
    v.poster = thumb.getAttribute('data-full') || '';
    v.controls = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.preload = 'metadata';
    var im = thumb.querySelector('img');
    v.setAttribute('aria-label', im ? im.getAttribute('alt') : 'Video du produit');
    return v;
  }

  /* Ordinateur : swap image <-> lecteur dans .lp9-media */
  function initDesktop(media, thumbs) {
    var player = null;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        if (isMobile()) { return; }
        if (t.classList.contains('lp9-thumb--video')) {
          if (!player) {
            player = makeVideo(t, 'lk-video-main');
            media.appendChild(player);
          } else if (player.getAttribute('src') !== t.getAttribute('data-video')) {
            player.src = t.getAttribute('data-video');
            player.poster = t.getAttribute('data-full') || '';
          }
          media.classList.add('lk-video-on');
          player.hidden = false;
          var p = player.play();
          if (p && p.catch) { p.catch(function () {}); }
        } else if (player) {
          player.pause();
          player.hidden = true;
          media.classList.remove('lk-video-on');
        }
      });
    });
  }

  /* Mobile : la diapo de la video (meme index que la vignette) devient un lecteur */
  function graftSwipe(track, thumbs) {
    if (track.getAttribute('data-lk-video') === '1') { return; }
    var slides = track.querySelectorAll('.lk-swipe-slide');
    var players = [];
    thumbs.forEach(function (t, i) {
      if (!t.classList.contains('lp9-thumb--video') || !slides[i]) { return; }
      var old = slides[i].querySelector('img');
      var v = makeVideo(t, 'lk-video-slide');
      if (old) { slides[i].replaceChild(v, old); } else { slides[i].appendChild(v); }
      players.push(v);
    });
    track.setAttribute('data-lk-video', '1');
    if (players.length && 'IntersectionObserver' in window) {
      /* pause quand on glisse ailleurs ; sauf pendant l'arrivee demandee par la pastille (lkWant) */
      var io = new IntersectionObserver(function (e2) {
        e2.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting && e.intersectionRatio >= 0.5) { v.lkWant = false; return; }
          if (!v.lkWant) { v.pause(); }
        });
      }, { root: track, threshold: [0, 0.5] });
      players.forEach(function (v) { io.observe(v); });
    }
  }

  /* Mobile : la vignette video (ou la pastille) lance la lecture pendant le geste (iOS autorise le son),
     depuis le debut si elle etait finie, sans pause pendant que la diapo arrive (lkWant) */
  function playSlide() {
    var v = document.querySelector('#lkSwipeTrack video.lk-video-slide');
    if (!v) { return; }
    if (v.ended) { v.currentTime = 0; }
    v.lkWant = true;
    setTimeout(function () { v.lkWant = false; }, 1500);
    var p = v.play();
    if (p && p.catch) { p.catch(function () {}); }
  }

  /* Option C : pastille sur la photo + duree sur la vignette */
  function addPill(media, vthumb) {
    var d = duree(vthumb);
    if (d && !vthumb.querySelector('.lk-vt-dur')) {
      var tag = document.createElement('span');
      tag.className = 'lk-vt-dur';
      tag.setAttribute('aria-hidden', 'true');
      tag.textContent = d;
      vthumb.appendChild(tag);
    }
    if (media.querySelector('.lk-video-pill')) { return; }
    var im = vthumb.querySelector('img');
    var alt = im ? (im.getAttribute('alt') || '') : '';
    var label = /d[e\u00e9]gustation/i.test(alt) ? 'Voir la d\u00e9gustation' : 'Voir la vid\u00e9o';
    var pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'lk-video-pill';
    pill.setAttribute('aria-label', label + (d ? ', ' + d : ''));
    pill.innerHTML = '<span class="lk-vp-ico">' + PLAY + '</span><span class="lk-vp-txt"></span>' +
      (d ? '<span class="lk-vp-dur"></span>' : '');
    pill.querySelector('.lk-vp-txt').textContent = label;
    if (d) { pill.querySelector('.lk-vp-dur').textContent = d; }
    /* la pastille fait exactement comme la vignette video (lecture sur ordinateur et sur mobile) */
    pill.addEventListener('click', function () { vthumb.click(); });
    media.appendChild(pill);

    /* la pastille se cache quand la video est a l'ecran (clic ordinateur ou glissement mobile) */
    function sync() {
      var visible = vthumb.classList.contains('is-active') || media.classList.contains('lk-video-on');
      pill.hidden = visible;
      if (!visible) {
        /* la video n'est plus a l'ecran (photo choisie ou glissee) : pause immediate */
        var vs = document.querySelectorAll('#lkSwipeTrack video.lk-video-slide');
        for (var k = 0; k < vs.length; k++) { vs[k].lkWant = false; vs[k].pause(); }
      }
    }
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(sync);
      mo.observe(vthumb, { attributes: true, attributeFilter: ['class'] });
      mo.observe(media, { attributes: true, attributeFilter: ['class'] });
    }
    sync();
  }

  function init() {
    var media = document.querySelector('.lp9-media');
    var wrap = document.querySelector('.lp9-thumbs');
    if (!media || !wrap || media.getAttribute('data-lk-video') === '1') { return; }
    var thumbs = Array.prototype.slice.call(wrap.querySelectorAll('.lp9-thumb'));
    var vthumb = null;
    thumbs.forEach(function (t) { if (!vthumb && t.classList.contains('lp9-thumb--video')) { vthumb = t; } });
    if (!vthumb) { return; }
    media.setAttribute('data-lk-video', '1');
    addStyle();
    initDesktop(media, thumbs);
    /* ecoute sur le conteneur, en capture : sur mobile, lk-gallery-swipe.js arrete le clic sur la vignette
       (stopImmediatePropagation), un ecouteur pose sur la vignette ne serait jamais appele */
    wrap.addEventListener('click', function (e) {
      if (isMobile() && vthumb.contains(e.target)) { playSlide(); }
    }, true);
    addPill(media, vthumb);

    /* le carrousel mobile peut etre construit avant ou apres ce script */
    var track = document.getElementById('lkSwipeTrack');
    if (track) { graftSwipe(track, thumbs); return; }
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        var tr = document.getElementById('lkSwipeTrack');
        if (tr) { mo.disconnect(); graftSwipe(tr, thumbs); }
      });
      mo.observe(media, { childList: true });
      setTimeout(function () { mo.disconnect(); }, 15000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
